import React, { useEffect, useState } from "react";
import { Modal, Flex, Button, Tooltip } from "antd";
import CustomTable from "../../Component/Table";
import {
  listMassNotificationUsers, downloadMassnotificationUsers
} from "../../Services/subscription"
import { useQuery, useMutation } from "@tanstack/react-query";
import { formatDate } from "../../utils/date";

const ViewUserModal = ({
  isModalVisible,
  handleCancel,
  massNotificationData
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [massNotificationID, setMassNotificationID] = useState(null)

  const skip = (currentPage - 1) * pageSize;


  const { data, isLoading } = useQuery({
    queryKey: ["mass_users", currentPage, pageSize, massNotificationID],
    queryFn: () =>
      listMassNotificationUsers({
        skip,
        limit: pageSize,
        mass_notification_id: massNotificationID
      }),
    enabled: !!massNotificationID && isModalVisible,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const columns = [
    // { title: "ID", dataIndex: "id", key: "id" },
    { title: "User Id", dataIndex: "receiver_id", key: "receiver_id" },
    { title: "User Name", dataIndex: "user_name", key: "user_name" },
    { title: "User Email", dataIndex: "user_email", key: "user_email" },
    { 
      title: "Is Notification Seen",
      dataIndex: "is_notification_seen",
      key: "is_notification_seen", 
      render: (val) => (val ? "Yes" : "No"),
    },
    {
      title: "Seen Date & Time",
      dataIndex: "seen_date_time",
      key: "seen_date_time",
      render: (text) => (text ? formatDate(text) : "-"),
    },
    { 
      title: "Is Push Clicked",
      dataIndex: "is_push_clicked",
      key: "is_push_clicked",
      render: (val) => (val ? "Yes" : "No"), 
    },
    {
      title: "Push Click Date & time",
      dataIndex: "push_clicked_datetime",
      key: "push_clicked_datetime",
      render: (text) => (text ? formatDate(text) : "-"),
    },
    {
      title: "Feedback Given",
      dataIndex: "is_feedback_given",
      key: "is_feedback_given",
      render: (val) => (val ? "Yes" : "No"),
    },
    {
      title: "Useful?",
      dataIndex: "is_feedback_usefull",
      key: "is_feedback_usefull",
      render: (val) => (val === null || val === undefined ? "-" : val ? "Yes" : "No"),
    },
    {
      title: "Feedback Text",
      dataIndex: "feedback_text",
      key: "feedback_text",
      render: (text) =>
        text && text.length > 40 ? (
          <Tooltip title={text}>{text.slice(0, 40) + "..."}</Tooltip>
        ) : (
          text || "-"
        ),
    },
    {
      title: "Feedback Date & Time",
      dataIndex: "feedback_submitted_at",
      key: "feedback_submitted_at",
      render: (text) => (text ? formatDate(text) : "-"),
    },
  ];

  useEffect(() => {
    if (isModalVisible) {
      setMassNotificationID(massNotificationData.id)
      setCurrentPage(1);
      console.log("call the model", massNotificationData)
    }
  }, [isModalVisible, massNotificationData]);

  const { mutate: triggerDownload, isPending: isDownloading } = useMutation({
    mutationFn: async () => {
      return await downloadMassnotificationUsers({
        mass_notification_id: massNotificationID ,
      });
    },
  });

  return (
    <Modal
      title=""
      open={isModalVisible}
      footer={null}
      width={800}
      onCancel={() => {
        handleCancel();
      }}
      maskClosable={false}
    >
      <div>
        <br/>
        <Flex justify="space-between" align="center">
          <h3>#{massNotificationID} Mass notification Users</h3>
          <Button type="primary" onClick={triggerDownload} loading={isDownloading}>Export</Button>
        </Flex>
        <br/>

        <CustomTable
          columns={columns}
          data={data?.notifications || []}
          loading={isLoading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: data?.total_count || 0,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            position: ["bottomRight"],
          }}
          onTableChange={handleTableChange}
          maxHeight="calc(100vh - 300px)"
        />

      </div>
    </Modal>
  );
};

export default ViewUserModal;
